// import React, { useEffect, useRef, useState } from "react";
// import DocumentVerificationForm from "./documentVerificationForm";
// import { ShieldCheckIcon } from "@heroicons/react/solid";

// import {
//   BetaForm as useBetaForm,
//   PickerRadioSimple,
//   FileUploaderBase,
//   ButtonBase,
//   TextInputBase,
// } from "@reusejs/react";
// import { createFile, verifyKyc } from "services";
// import Loader from "../../../layouts/Loader";

// export default function PanVerificationForm(props: any) {
//   const fileRef: any = useRef();
//   const [selectedFile, setSelectedFile] = useState<any>([]);
//   const [uploadedFile, setUploadedFile] = useState<any>(null);
//   const [panHolderName, setPanHolderName] = useState<string>("");
//   const panForm = useBetaForm({
//     pan_type: {
//       label: "Individual",
//       value: "individualPan",
//     },
//     id_number: "",
//     errors: "",
//   });
//   const form_constraints = {
//     pan_type: {
//       presence: {
//         allowEmpty: false,
//       },
//     },
//     id_number: {
//       presence: {
//         allowEmpty: false,
//         message: "Pan Number can't be empty.",
//       },
//       length: {
//         is: 10,
//         message: "Pan should be 10 Character long",
//       },
//     },
//     errors: {
//       presence: {
//         allowEmpty: true,
//       },
//     },
//   };

//   useEffect(() => {
//     panForm.setValidationRules(form_constraints);
//   }, []);

//   const handlePanVerification = async () => {
//     try {
//       console.log("clicked", panForm, panForm.validate());
//       setPanHolderName("MD AMIR SOHAIL");
//       if (panForm.validate()) {
//         panForm.startProcessing();
//         let payload = {
//           bidder_uuid: props.data?.uuid,
//           document_type: panForm.value.pan_type.value, // "individual/business"
//           id_number: panForm.value.id_number,
//           id_details: { name: panForm.value.name },
//         };

//         const data: any = await verifyKyc(payload);
//         // setPanHolderName(data[1].result.name);
//         if (props.callback && data) {
//           if (
//             data.kyc_data.pan_data.signzy_response.response.result.verified ==
//             true
//           ) {
//             props.callback(data);
//           } else {
//             panForm.setField(
//               "errors",
//               "Name or Pan Not Matched Please Check Again"
//             );
//           }
//         }
//         panForm.finishProcessing();
//       }
//     } catch (error: any) {
//       panForm.finishProcessing();
//       if (error.response?.data) {
//         panForm.setField("errors", error.response.data.message);
//       }
//     }
//   };

//   return (
//     <div className="w-full mt-8">
//       <PickerRadioSimple
//         labelBaseProps={{
//           label: "PAN - Individual/Business*",
//         }}
//         name="pan_type"
//         dataSource={(q: any) => {
//           return [
//             {
//               label: "Individual",
//               value: "individualPan",
//             },
//             {
//               label: "Business",
//               value: "businessPan",
//             },
//           ];
//         }}
//         defaultSelected={
//           panForm.getField("pan_type") !== ""
//             ? [panForm.getField("pan_type")]
//             : [
//                 {
//                   label: "Individual",
//                   value: "individualPan",
//                 },
//               ]
//         }
//         onChange={(value) => panForm.setField("pan_type", value)}
//         valueKey="value"
//         optionsRenderer={{}}
//         scrollableBaseProps={{
//           scrollableBaseClasses: {
//             position:
//               "z-50 block space-y-4 sm:flex sm:items-center sm:space-y-0 sm:space-x-10",
//             maxHeight: "",
//             border: " ",
//             background: " ",
//           },
//         }}
//         radioOptionLabelClasses={{
//           color: " ",
//           alignment: "ml-3 block",
//         }}
//         radioBoxStyleClasses={{
//           focus: "checked:bg-blue-500 text-blue-500",
//           wrapper: "mt-0",
//           alignment: "flex justify-center items-center",
//           width: "h-4 w-4",
//           borderRadius:
//             "rounded-full border-slate-500 border bg-white focus:ring-blue-500 checked:bg-white checked:border-4 checked:border-blue-500",
//           border: " ",
//           padding: "",
//           font: "",
//           textColor: "text-gray-900 dark:text-white",
//           backgroundColor: "bg-white dark:bg-gray-900",
//           placeholderColor: "",
//         }}
//         pickerRadioBaseClasses={{
//           wrapper: "mt-2",
//         }}
//       />
//       <div className="my-6 ">
//         <div className="flex flex-col">
//           <div className="my-4">
//             <TextInputBase
//               htmlFor="id_number"
//               labelBaseProps={{
//                 label: "Enter Your Pan Number",
//               }}
//               textInputBaseClasses={{
//                 wrapper: "max-w-xs",
//               }}
//               name="id_number"
//               onChange={(v: any) => {
//                 panForm.setField("id_number", v.toLocaleUpperCase());
//                 panForm.validate();
//                 setPanHolderName("");
//                 panForm.setField("errors", "");
//               }}
//               placeholder="Ex-CXAP1234P"
//               type="text"
//               value={panForm.getField("id_number")}
//             />
//           </div>
//         </div>
//         {panHolderName && (
//           <p className="text-md text-black font-bold flex">
//             <ShieldCheckIcon className="h-6 w-6 text-green-500 mr-2" />
//             {panHolderName}
//           </p>
//         )}
//         {panForm.errors.get("id_number") ? (
//           <p className="mt-2 text-sm text-red-500">
//             {panForm.errors.get("id_number")[0].slice(10)}
//           </p>
//         ) : null}
//         {panForm.getField("errors") ? (
//           <p className="mt-2 text-sm text-red-500">
//             {panForm.getField("errors")}
//           </p>
//         ) : null}
//       </div>

//       {panHolderName && <DocumentVerificationForm />}
//       {!panHolderName && (
//         <ButtonBase
//           variant="primary"
//           type="button"
//           label={"Verify"}
//           onClick={() => {
//             if (panForm.getField("id_number").length == 10) {
//               handlePanVerification();
//             }
//           }}
//           buttonBaseClasses={{
//             font: "text-base font-medium",
//             backgroundColor: "bg-blue-600 hover:bg-blue-700",
//             textColor: "text-white",
//             border: "any",
//             width: "w-32",
//             padding: "px-4 py-3",
//           }}
//           busy={panForm.busy}
//           busyText={<Loader height="h-6" width="w-6" />}
//         />
//       )}
//     </div>
//   );
// }
import React, { useEffect, useRef, useState } from "react";
import {
  BetaForm as useBetaForm,
  PickerRadioSimple,
  FileUploaderBase,
  ButtonBase,
} from "@reusejs/react";
import { createFile, verifyKyc } from "services";
import Loader from "../../../layouts/Loader";
import { useSelector } from "react-redux";
export default function PanVerificationForm(props: any) {
  const onboarding: any = useSelector((state: any) => {
    return state.bidderAuth.onboarding;
  });

  const fileRef: any = useRef();
  const [selectedFile, setSelectedFile] = useState<any>([]);
  const [uploadedFile, setUploadedFile] = useState<any>(null);
  const panForm = useBetaForm({
    front: "",
  });
  const form_constraints = {
    front: {
      presence: {
        allowEmpty: false,
        message: "image can't be empty.",
      },
    },
  };

  useEffect(() => {
    panForm.setValidationRules(form_constraints);
  }, []);

  const handlePanVerification = async () => {
    try {
      console.log("clicked", panForm, panForm.validate());
      if (panForm.validate()) {
        panForm.startProcessing();
        let payload = {
          bidder_uuid: props.data?.uuid,
          document_type:
            onboarding?.type === "individual" ? "individualPan" : "businessPan",
          front: `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${panForm.value.front}?fm=jpg`, //"file_uuid",
        };

        console.log("pan_data:>", payload);
        const data = await verifyKyc(payload);
        if (props.callback && data) {
          props.callback(data);
        }
        panForm.finishProcessing();
      }
    } catch (error: any) {
      console.log("check error:", error);
      panForm.finishProcessing();
      if (error.response.data) {
        if (error.response.data.message === "Upstream Down")
          panForm.setErrors({ front: ["External API ERROR"] });
        else panForm.setErrors({ front: [error.response.data.message] });
      }
    }
  };

  return (
    <div className="w-full mt-8">
      {onboarding?.type === "individual" ? (
        <div className="text-gray-900">{`PAN - Individual`}</div>
      ) : (
        <div className="text-gray-900">{`PAN - Business`}</div>
      )}
      <div className="my-6 ">
        <label
          htmlFor="front"
          className="block text-sm font-medium text-gray-800 mb-4"
        >
          Front*
        </label>

        <FileUploaderBase
          ref={fileRef}
          multiple={false}
          accept={"*/*"}
          autoUpload={true}
          upload={async (uploadedFile) => {
            const data: any = await createFile(uploadedFile, {
              owner_identifier: props.data?.uuid,
              owner_service: "bidder-kyc-pan",
            });
            setUploadedFile(data);
            panForm.setField("front", data.uuid);
          }}
          beforeUpload={(uploadedFiles) => {
            console.log("beforeUpload:beforeUpload:>", uploadedFiles);
          }}
          afterUpload={async (uploadedFiles) => {
            console.log("beforeUpload:afterUpload:>", uploadedFiles);
          }}
          openFileUploader={(triggerClickHandler) => (
            <div
              className="h-48 w-72 sm:w-80 cursor-pointer"
              onClick={async () => await triggerClickHandler()}
            >
              {selectedFile.length > 0 ? (
                <img
                  className="h-full w-full rounded-md object-cover"
                  src={
                    `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${uploadedFile?.uuid}?fm=jpg`
                    // URL.createObjectURL(selectedFile[0].file)
                  }
                />
              ) : (
                <label className="w-72 sm:w-80 h-full flex flex-col justify-center items-center px-4 py-6 bg-white text-gray-600 rounded-lg shadow-lg tracking-wide uppercase border hover:bg-blue-200 hover:border-blue-600 hover:text-blue-600">
                  <svg
                    className="w-8 h-8"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                  </svg>
                  <span className="mt-2 text-base leading-normal">
                    Select a file
                  </span>
                </label>
              )}
            </div>
          )}
          selectedFiles={(file) => {
            console.log("selected file:>", file);
            setSelectedFile(file);
          }}
        />
        <label
          htmlFor="front"
          className="block text-sm font-medium text-gray-500 mt-3"
        >
          Please upload the front image of your PAN.
        </label>
        {panForm.errors.get("front") ? (
          <p className="mt-2 text-sm text-red-500">
            {panForm.errors.get("front")[0]}
          </p>
        ) : null}
      </div>
      <ButtonBase
        variant="primary"
        type="button"
        label={"Verify"}
        onClick={() => handlePanVerification()}
        buttonBaseClasses={{
          font: "text-base font-medium",
          backgroundColor: "bg-blue-600 hover:bg-blue-700",
          textColor: "text-white",
          border: "any",
        }}
        busy={panForm.busy}
        busyText={<Loader height="h-6" width="w-6" />}
      />
    </div>
  );
}
